import styled from "styled-components";
import { colors } from "../../utils/styles/theme";
import { EASE_FUNC } from "../../utils/styles/animations";
import { mediaDesktop, mediaMobile } from "../../utils/styles/responsive";

export const ButtonWrapper = styled.div`
  width: 100%;
  height: auto;
`;

export const Button = styled.button`
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid ${colors.white};
  font-family: FontRegular;
  font-size: 9rem;
  color: ${colors.white};
  border-radius: 40rem;
  padding: 8rem 12rem;
  transition: background-color 0.2s ${EASE_FUNC.easeInOut},
    color 0.23s ${EASE_FUNC.easeInOut};

  ${mediaDesktop(`
    padding: 10rem 16rem;
    font-size: 16rem;
    &:hover {      
      // border: 4rem solid ${colors.black};
      background-color: ${colors.white};
      color: ${colors.black};
    }
  `)}
`;
export const ButtonSolid = styled.button`
  width: 100%;
  height: 100%;
  background-color:  ${colors.white};
  font-family: FontRegular;
  font-size: 10rem;
  color: ${colors.black};
  border-radius: 40rem;
  padding: 10rem 16rem;
  transition: background-color 0.2s ${EASE_FUNC.easeInOut},
    color 0.2s 0.1s ${EASE_FUNC.easeInOut}, border 0.2s ${EASE_FUNC.easeInOut};

  ${mediaDesktop(`
    font-size: 16rem;
    &:hover {      
      background-color: ${colors.black};
      color: ${colors.white};
    }
  `)}
`;

export const Icon = styled.button`
  width: 120rem;
  height: 120rem;
  background-color: ${colors.white};
  border: 4rem solid ${colors.white};
  border-radius: 50%;

  ${mediaMobile(`
    width: 60rem;
    height: 60rem;
    margin: 0 auto;
    display: block;
  `)};
`;
